/**
 * EmptyState component - Display when no folders are available
 */

import React from 'react';

const EmptyState: React.FC = () => {
  return (
    <div className="outreach-empty-state">
      <div className="empty-icon" aria-hidden="true">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12 18C12 16.3431 13.3431 15 15 15H27.1716C28.2324 15 29.2496 15.4214 30.0 16.1716L33.8284 20C34.5786 20.7502 35.5959 21.1716 36.6568 21.1716H49C50.6569 21.1716 52 22.5147 52 24.1716V46C52 47.6569 50.6569 49 49 49H15C13.3431 49 12 47.6569 12 46V18Z"
            fill="#E5E7EB"
          />
          <path
            d="M12 24C12 22.3431 13.3431 21 15 21H49C50.6569 21 52 22.3431 52 24V28H12V24Z"
            fill="#D1D5DB"
          />
        </svg>
      </div>
      <p className="empty-message">No templates available yet</p>
    </div>
  );
};

export default EmptyState;

